export * from './DepositoServiceAdapter'
export * from './EstoqueServiceAdapter'
